import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';
import { PaymentFormModule } from 'src/app/shared/components/payment-form/payment-form.module';
import { ProductChoiceModule } from 'src/app/shared/components/product-choice/product-choice.module';

import { SelfAttendancePaymentChangeComponent } from './payment-change.component';

import {CommonModule} from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MobileDropdownModule } from 'src/app/shared/components/mobile-dropdown/mobile-dropdown.module';

@NgModule({
  imports: [
    HeroModule,
    MatDividerModule,
    PaymentFormModule,
    ProductChoiceModule,
    CommonModule,
    
    MatCardModule,
    MobileDropdownModule,
    MatIconModule
  ],
  exports: [
    SelfAttendancePaymentChangeComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendancePaymentChangeComponent
  ]
})

export class SelfAttendancePaymentChangeModule { }
